import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {ProviderServiceCoveringModel} from "../providerServiceCovering.model";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceCoveringConverter extends HttpModelConverter<ProviderServiceCoveringModel> {

    constructor() {
        super();
    }

    protected createInstance(): ProviderServiceCoveringModel {
        return new ProviderServiceCoveringModel();
    }

    protected enrichObject(result: ProviderServiceCoveringModel, src: ProviderServiceCoveringModel) {
    }
}
